import styled from "styled-components";
import { StyledButton } from "@mlb/react-patterns/dist/components/Button/button.style";
import COLORS from "@mlb/react-patterns/dist/style/universal.color";
import { SpotTagContainer } from "@mlb/react-patterns/dist/components/SpotTag/spotTag.style";
var mlbWhite = COLORS.mlbWhite;
export var FollowRowContainer = styled.div.withConfig({
  displayName: "styles__FollowRowContainer",
  componentId: "sc-1v5tqfm-0"
})(["", "{justify-content:space-between;", "{padding:0;width:86px;&[data-focus-visible-added]{box-shadow:0 0 0 3px ", ";outline:none;}span{display:block;overflow:hidden;padding:0 7px;text-overflow:ellipsis;white-space:nowrap;}}}"], SpotTagContainer, StyledButton, function (_ref) {
  var dark = _ref.dark,
    isFollowed = _ref.isFollowed;
  return isFollowed && dark ? mlbWhite : "rgba(0, 137, 255, 0.65)";
});